import http from '../../../utils/fetch';
export default {
    showPage(query){
        return http({
            url: '/api/swyl/v1/demo/bscForecastDetailCore/showPage',
            method: 'post',
            params: query
        });
    },
    showLName(){
        return http({
            url: '/api/swyl/v1/demo/bscForecastplanDetailed/selectLeName',
            method: 'post'
        });
    },
    page(query) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastDetailCore/selectPage',
            method: 'post',
            params: query
        });
    },
    saveTo(obj){
        return http.post('/api/swyl/v1/demo/bscForecastDetailCore/saveTo',obj);
    },
    toshow(pageId,nextShow){
        return http({
            url: '/api/swyl/v1/demo/bscNoviceGuideDetail/isShowNoviceGuide',
            method: 'post',
            params: {pageId,nextShow}
        });
    },
}